import { createContext } from "react"

export const UnderMaintenanceContext = createContext({
  underMaintenanceModalOpen: false,
  openUnderMaintenanceModal: () => {} /* eslint-disable-line */,
  closeUnderMaintenanceModal: () => {} /* eslint-disable-line */,
})
